import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { JournalProvider } from './context/JournalContext';
import { DisplayModeProvider } from './context/DisplayModeContext';
import { Sidebar, TabKey } from './components/layout/Sidebar';
import { SaveErrorToast } from './components/layout/SaveErrorToast';
import { Topbar } from './components/layout/Topbar';
import { CalendarPage } from './pages/CalendarPage';
import { DashboardPage } from './pages/DashboardPage';
import { TagManager } from './components/tags/TagManager';
import { TrashPage } from './pages/TrashPage';
import { ProfilePage } from './pages/ProfilePage';
import { SignInPage } from './pages/auth/SignInPage';
import { SignUpPage } from './pages/auth/SignUpPage';
import { RecoverPage } from './pages/auth/RecoverPage';
type AuthScreen = 'signIn' | 'signUp' | 'recover';
export function App() {
  return <AuthProvider data-id="element-0" data-mp="23vune9yyeqtk">
      <AppRoutes data-id="element-1" data-mp="23u9ueosaffxt" />
    </AuthProvider>;
}
function AppRoutes() {
  const {
    user,
    loading,
    passwordRecovery,
    clearPasswordRecovery
  } = useAuth();
  const [screen, setScreen] = useState<AuthScreen>('signIn');
  if (loading) {
    return <div className="flex min-h-screen w-full items-center justify-center bg-white" data-id="element-2" data-mp="3mjg8bgx1m1k3">
        <p className="text-[13px] text-ink-soft" data-id="element-3" data-mp="3rd1all5o5hp3">Cargando tu cuenta…</p>
      </div>;
  }

  // A password-recovery link always takes over, even if it happens to open an
  // existing session: the user must set a new password before doing anything else.
  if (passwordRecovery) {
    return <RecoverPage onSignIn={() => {
      clearPasswordRecovery();
      setScreen('signIn');
    }} forceReset data-id="element-4" data-mp="33n6zb810016y" />;
  }

  // Private routes are unreachable without an active session.
  if (!user) {
    if (screen === 'signUp') return <SignUpPage onSignIn={() => setScreen('signIn')} data-id="element-5" data-mp="3dm5y7yvyoigr" />;
    if (screen === 'recover') return <RecoverPage onSignIn={() => setScreen('signIn')} data-id="element-6" data-mp="nv0ybtt2yq5o" />;
    return <SignInPage onSignUp={() => setScreen('signUp')} onForgot={() => setScreen('recover')} data-id="element-7" data-mp="su43de928wdn" />;
  }
  return <JournalProvider data-id="element-8" data-mp="35oxut5vn8u6">
      <DisplayModeProvider data-id="element-9" data-mp="34x1vh8db93d">
        <PrivateApp data-id="element-10" data-mp="38b5essrpoce" />
        <SaveErrorToast data-id="element-11" data-mp="3ud1g7bihxsbo" />
      </DisplayModeProvider>
    </JournalProvider>;
}
function PrivateApp() {
  const [tab, setTab] = useState<TabKey>('calendar');
  return <div className="flex h-full min-h-screen w-full bg-white text-ink" data-id="element-12" data-mp="d2l8b4fc651d">
      <Sidebar active={tab} onChange={setTab} data-id="element-13" data-mp="86w3omoglxy7" />
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-14" data-mp="3gle9siuub3f6">
        <Topbar active={tab} onChange={setTab} data-id="element-15" data-mp="3glwc9x83idvj" />
        <main className="min-w-0 flex-1 overflow-y-auto" data-id="element-16" data-mp="3bmjqlfsyncuj">
          {tab === 'calendar' && <CalendarPage data-id="element-17" data-mp="3bkgse8hnmdeq" />}
          {tab === 'dashboard' && <div className="px-5 py-6 md:px-8 md:py-8" data-id="element-18" data-mp="3qcqzp4x2vjik">
              <DashboardPage data-id="element-19" data-mp="3lkr2hk8e74po" />
            </div>}
          {tab === 'tags' && <div className="px-5 py-6 md:px-8 md:py-8" data-id="element-20" data-mp="2xun1zlqi3l2w">
              <TagManager data-id="element-21" data-mp="2xt27tx83m45k" />
            </div>}
          {tab === 'trash' && <div className="px-5 py-6 md:px-8 md:py-8" data-id="element-22" data-mp="2svahh7n3qq3h">
              <TrashPage data-id="element-23" data-mp="18e171cv5hagc" />
            </div>}
          {tab === 'profile' && <div className="px-5 py-6 md:px-8 md:py-8" data-id="element-24" data-mp="1d47wfexhkyzn">
              <ProfilePage data-id="element-25" data-mp="1d62l94bvpb90" />
            </div>}
        </main>
      </div>
    </div>;
}